/**
 * Stable device identity for custom indicator build provenance.
 */

import type { CustomIndicatorBuildDevice } from "./types";

const DEVICE_ID_KEY = "vybe_custom_indicator_device_id";
const DEVICE_LABEL_KEY = "vybe_custom_indicator_device_label";

function randomId(): string {
  return `dev_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
}

export function getDeviceId(): string {
  if (typeof window === "undefined") return "server";
  try {
    let id = localStorage.getItem(DEVICE_ID_KEY);
    if (!id) {
      id = randomId();
      localStorage.setItem(DEVICE_ID_KEY, id);
    }
    return id;
  } catch {
    return randomId();
  }
}

export function getDeviceLabel(): string {
  if (typeof window === "undefined") return "Server";
  try {
    const stored = localStorage.getItem(DEVICE_LABEL_KEY);
    if (stored?.trim()) return stored.trim();
  } catch {
    /* ignore */
  }
  return defaultDeviceLabel();
}

export function setDeviceLabel(label: string): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(DEVICE_LABEL_KEY, label.trim());
  } catch {
    /* ignore */
  }
}

function defaultDeviceLabel(): string {
  if (typeof navigator === "undefined") return "Unknown device";
  const platform = navigator.platform?.trim();
  if (platform) return platform;
  return "This device";
}

export function getBuildDeviceInfo(): CustomIndicatorBuildDevice {
  return {
    id: getDeviceId(),
    label: getDeviceLabel(),
    userAgent:
      typeof navigator !== "undefined" ? navigator.userAgent : "",
    platform:
      typeof navigator !== "undefined" ? (navigator.platform ?? "") : "",
  };
}
